import FinawardsIcon from './FinawardsIcon';

export default FinawardsIcon;
